// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//Third Party
//import moment from 'moment';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
//import { FormDataService2 } from '../../shared/services/formData2';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';

//Classes
import { FormAction } from "../../shared/classes/formAction";

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';


//Config/Globals
import { Enums } from '../../shared/enums.js';

//Token
import { authToken } from '../../shared/authToken';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CppeMainComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    styles : ['.capp-main-content-div{position:absolute;top:0;right:0;bottom:0;left:0px;display:flex;flex-direction:column;min-width:450px}.capp-main-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0 8px 10px 8px;padding:0 8px;background-color:#eee;border:solid 1px #ddd;border-radius:4px}.capp-filter-control-div{flex-grow:0;display:flex;align-items:center;margin:0 8px 10px 8px;padding:0 8px;border-radius:4px}.capp-legend-item-div{margin:0 16px 0 2px}.capp-main-grid-div{flex-grow:1;position:relative;margin-top:15px;border-top:solid 1px #ccc}.capp-control-lbl{margin-right:4px}.capp-filter-radio{padding-left:10px;display:flex;align-items:center}.capp-main-control-break{flex-basis:100%;height:0}.capp-cssClasses_Grid{border-top:solid 1px #bbb}.capp-cssClasses_Cell{border-right:solid 1px #ccc;padding:2px 4px !important;margin:0}.capp-cssClasses_EditableCell_incomplete{border:solid 1px orange !important}.capp-cssClasses_EditableCell_complete{border:solid 1px green !important}'],
    template : '<!--Content Div-->\n<div class="capp-main-content-div" data-test-id="content_capp_narrative_dashboard">\n\n    <!-- ---------------------------------------------------- -->\n    <!-- Title -->\n    <!-- ---------------------------------------------------- -->\n    <h2 tabindex="-1" class="cpd-title-div">{{_title}}</h2>\n    <div id="divSubtitle" class="cpd-subtitle-div">{{_divSubtitle}}</div>\n\n    <!--Content Loading -->\n    <div *ngIf="casNavBoxService.ActionsLoading || _pageLoading" class="cpd-ui-content-loading">\n        <img src="public/cpd-images/loading.gif" />\n        <div style="margin-left:10px;">Loading...</div>\n    </div>\n\n    <!--CONTENT CONTAINER (hidden during loading operations)-->\n    <ng-container *ngIf="!_pageLoading">\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Control Div -->\n        <!-- ---------------------------------------------------- -->\n        <div class="capp-main-control-div">\n\n            <!--FISCAL YEAR-->\n            <div class="cpd-control-unit" style="padding-right:10px; border-right:solid 1px #ccc;">\n                <span>Fiscal Year:&nbsp;</span>{{_fiscalYear}}\n            </div>\n\n            <!--Practice-->\n            <div class="cpd-control-unit" style="margin-left:10px;">\n                <span>Asset:&nbsp;</span>{{_practiceDisplay}}\n            </div>\n        </div>\n\n        <!-- ---------------------------------------------------- -->\n        <!-- Grid Div -->\n        <!-- ---------------------------------------------------- -->\n        <div class="capp-main-grid-div">\n            <cas-grid #mainGrid\n                      [settings]="_mainGridSettings"\n                      summary="{{_title}}"\n                      (onCellClicked)="onCellClicked($event)"\n                      (onPageChanged)="onPageChanged($event)"\n                      (onRowSelectionChanged)="onRowSelectionChanged()"\n                      (onRefreshClicked)="gridRefreshClicked()"\n                      (onSearch)="onGridSearch($event)"\n                      (onSort)="onSort($event)">\n            </cas-grid>\n        </div>\n\n\n    </ng-container>\n\n    <!--POPUP INSTANCE CONTAINER-->\n    <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n    where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n    are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n    <div id="capp_narrative_dashboard_page_popups"></div>\n\n    <!-- Full Narrative Text Popup-->\n    <modal #fullTextPopup \n           containerId="capp_narrative_dashboard_page_popups"\n           title="Narrative Text" \n           label="fullTextPopup">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_fulltext_capp_narrative_dashboard"></section>\n\n        <!-- body -->\n        <section>\n            <div class="cpd-ui-row">\n                <div class="cpd-ui-cell" style="width:100%">\n                    {{_fullTextDisplay}}\n                </div>\n            </div>\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">OK</button>\n        </footer>\n    </modal>\n\n    <!-- Approve For Publishing Popup-->\n    <modal #approveForPublishingPopup \n           containerId="capp_narrative_dashboard_page_popups"\n           title="Confirmation of Approval" \n           label="approveForPublishingPopup">\n\n        <!-- body -->\n        <section>\n            <div class="cpd-ui-row" style="text-align:center">\n                Are you sure you want to approve for publishing? Have points been reviewed or assigned? This action cannot be reversed.\n            </div>\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n            <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="ApproveNarrativeForPublishing()">Approve</button>\n        </footer>\n    </modal>\n\n</div>\n',
    providers:[],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class CappNarrativeDashboardComponent implements OnInit {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('mainGrid') mainGrid;
    @ViewChild('fullTextPopup') fullTextPopup;
    @ViewChild('approveForPublishingPopup') approveForPublishingPopup;

    //Class wide member reference for the growls control
    growlBox = null;


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _authToken = authToken; //authToken sometimes acts weird sometimes if you don't assign it locally

    //Boiler Plate
    _componentName = 'cappNarrativeDashboard.js';
    _disableControls = false;
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _formName = 'cappNarrativeDashboard';
    _pageLoading = true;
    _sessionStorageObject = null;
    _title = "CAPP - Narrative List";

    //Data
    //_fiscalYears = [];
    //_selectedFY;
    _currentFYData = null;
    _divSubtitle = "Select a narrative to view points"; //Actual value set below based on role.
    _fiscalYear = 2020;         //From route parameters
    _fullTextDisplay = "";      //Used in narrative text popup whena "link" is clicked
    _practiceId = null;         //Loaded from the practice state
    _practiceStateId = null;    //From route parameters
    _practiceDisplay = "";
    _selectedNarrative = null;

    //Main Grid
    _mainGridSettings = {
        hideClearSelectedButton: true,
        hideSearchBox:false,
        positionAbsolute: true,
        rows: [],
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "code",
        rowIdentityPrefixForJAWS: "Narrative Code",
        cssClasses_Grid: "capp-cssClasses_Grid",
        cssClasses_Cell: "capp-cssClasses_Cell",
        columns: [
            { fieldName: 'state_abbr', display: 'Level', width: '5%', minWidth: 50 },
            { fieldName: 'state_county_code', display: 'County', width: '5%', minWidth: 60 },
            { fieldName: 'practice_narrative_code', display: 'Code', width: '5%', minWidth: 60 },
            { fieldName: 'start_date', display: 'Start Date', width: '5%', minWidth: 80, procDataFn: (start_date, row) => { return this.cpdFormatters.formatDateString(start_date, "Pending"); }, columnHeaderToolTip: "Pending: Narrative not published." +"\n" + "Actual Date: Ex. 10/1/2021." },
            { fieldName: 'publish', display: 'Published', width: '5%', minWidth: 75 },
            { fieldName: 'narrative_status', display: 'Narrative Status', width: '5%', minWidth: 75, columnHeaderToolTip: "New: Narrative is new or revised but not published." + "\n" + "Current: Narrative is published." + "\n" + "Revised: Unpublished narrative or points have changed." },
            { fieldName: 'point_status', display: 'Point Status', width: '8%', minWidth: 100, columnHeaderToolTip: "No Points Found: No points related to narrative record." + "\n" + "Points Updated: Narrative points have been changed." + "\n" + "Points Not Updated: Narrative points not changed on revision." },
            { fieldName: 'publish_action', display: 'Publish Action', width: '6%', minWidth: 80, columnHeaderToolTip: "On Rollover: Narrative will automatically publish on FY Rollover." + "\n" + "Immediately: Narrative will publish immediately when Publish Immediately clicked." + "\n" + "NA: Narrative is already published." },
            { fieldName: 'approval_status', display: 'Approval Status', width: '6%', minWidth: 100, columnHeaderToolTip: "Pending: Narrative requires Approval." + "\n" + "Approved: Narrative is Approved but not Published." + "\n" + "Published: Narrative is Approved and Published." },
            { fieldName: 'last_change_date', display: 'Last Modified Date', width: '5%', minWidth: 90, procDataFn: (last_change_date, row) => { return this.cpdFormatters.formatDateString(last_change_date); }, },
            { fieldName: 'practice_narrative', display: 'Narrative', width: '45%', minWidth: 100, templateFn: (narrative) => { return this._generateNarrativeTextLink(narrative); } }
        ]
    };

//{ fieldName: 'start_date', display: 'Start Date', width: '10%', minWidth: 50, procDataFn: (val) => { return this.cpdFormatters.formatDateString(val, null) }, dataType: 'date' },
//{ fieldName: 'end_date', display: 'End Date', width: '10%', minWidth: 50, procDataFn: (val) => { return this.cpdFormatters.formatDateString(val, null) }, dataType: 'date' }


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService,
        //formDataService: FormDataService2,
        cpdFormatters: CPDFormatters,
        helpers: Helpers,
        activeRoute: ActivatedRoute,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

        // Growl Prep
        //--------------------
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({ 
	        appendToElementId:"cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        }); 

        //Init page
        this._markPageAsLoading(true);

        //Init local storage
        this._sessionStorageObject = this._loadSessionStorageObject();
        if (!this._sessionStorageObject) {

            this._sessionStorageObject = {
                selectedNarrative:null,
                currentPage:1
            }
            this._saveSessionStorageObject(this._sessionStorageObject);
        }

        //Actions
        //Handle clicks on the NavBox actions via the navBoxCommService
        let disposer = casNavBoxService.OnActionClicked$.subscribe(action => {
            this.navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        // Set title 
        //--------------------
        if (this._authToken.IsState()) {
            this._title = this._authToken.user.stateName + " - CAPP - Narrative List";
        }
        else {
            this._title = "CAPP - Narrative List";
        }

        // Debugging 
        //--------------
        //casNavBoxService.ClearDebugEntries();
        //casNavBoxService.DebugEntries.push("Navigate to Edit");

        //disposer = casNavBoxService.OnDebugEntryClicked$.subscribe(entry => {
        //    this.debugEntryClicked(entry);
        //});
        //this._disposalFunctions.push(disposer);

        this._disableControls = false;
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {

        console.log("\n[{0}:ngOnInit()]------------------------------------------------------------------------".format(this._componentName));

        //Mark the action links as loading so we can update them
        this.casNavBoxService.ActionsLoading = true;

        //508
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);

        // PARAMS
        //  (note that this is a snapshot and will not change without a page reload)
        //  (use rxjs if you need to react to changes. Ex: https://kamranahmed.info/blog/2018/02/28/dealing-with-route-params-in-angular-5/)
        this._fiscalYear = this.activeRoute.snapshot.params.fy;
        this._practiceStateId = this.activeRoute.snapshot.params.practiceStateId;

        //console.log("this._fiscalYear:", this._fiscalYear);
        //console.log("this._practiceStateId:", this._practiceStateId);

        //Async ops
        let ops = 3;

        //FORMS
        // Both National and State Data Stewards can now access this screen
        let actions = [];
        switch (this._authToken.user.role) {

            // NHQNationalPracticeDataSteward
            //-------------------------------------
            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                actions.push(new FormAction("act_view_points", "View Points"));
                actions.push(new FormAction("act_edit_points", "Edit Proposed Points"));
                actions.push(new FormAction("act_approve", "Approve for Publishing"));
                actions.push(new FormAction("act_publish", "Publish Immediately"));
                actions.push(new FormAction("act_manage_capp", "Manage Narratives", true, "Manage Narratives for current Asset"))

                this._divSubtitle = "Select a narrative to edit or view points. For editing, you will be modifying points staged for the next FY rollover. For published narratives, you will see a read only version of the currently published points."
                break;

            // NationalDisciplineDataSteward
            //-------------------------------------
            case Enums.Roles.NationalDisciplineDataSteward.id:
                actions.push(new FormAction("act_view_points", "View Points"));

                this._divSubtitle = "Select a narrative to view points.  Published points will be shown if any are available, otherwise proposed points will be shown if present."
                break;


            // StateDataSteward
            //-------------------------------------
            case Enums.Roles.StateDataSteward.id:
                actions.push(new FormAction("act_view_points", "View Points"));

                this._divSubtitle = "Select a narrative to view points.  Published points will be shown if any are available, otherwise proposed points will be shown if present."
                break;
        }
        
        console.log("[{0}:ngOnInit()] - actionLinks:".format(this._componentName, this._formName), actions);

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;

        //LOAD CURRENT FISCAL YEAR
        this.loadFY((dto) => {
            this._currentFYData = dto;
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //LOAD NARRATIVES
        this.loadNarratives(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

        //LOAD PRACTICE INFO
        this.loadPracticeState(this._practiceStateId, (dto)=>{
            this._practiceDisplay = dto.practice_code + " - " + dto.practice_name.substr(0,50);
            this._practiceId = dto.practice_id;
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

    };

    //=======================================
    // ngOnInit_Complete
    //=======================================
    // Called once all the async work in onInit is complete
    ngOnInit_Complete() {
        //console.log("ngOnInit_Complete");
        this.casNavBoxService.ActionsLoading = false;
        this._markPageAsLoading(false);
    };


    // SERVICE - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {

        switch (action.field_name.toLowerCase()) {

            case "act_view_points":
                
                //Make sure a narrative has been selected
                if (!this._selectedNarrative) {
                    this.growlBox.addGrowl("info", "Please select a row to view");
                    return;
                }

                //If there is a revision for this narrative, we want to view that revision
                let viewRoute = "/cpdes/capp/view/{0}/{1}/{2}".format(
                    this._fiscalYear, 
                    this._practiceStateId, 
                    //(this._selectedNarrative.revision_narrative_id || this._selectedNarrative.practice_narrative_id));
                    (this._selectedNarrative.practice_narrative_id)); //Alays show "original" points
                this.router.navigate([viewRoute]);

                break;

            case "act_edit_points":

                //Make sure a narrative has been selected
                if (!this._selectedNarrative) {
                    this.growlBox.addGrowl("info", "Please select a row to edit");
                    return;
                }

                //Check the FY.  User's cannot edit narratives from the past (only for the current FY, which will be rolled over to the next FY)
                if (this._currentFYData.fiscalYear != this._fiscalYear) {
                    this.growlBox.addGrowl("info", "Points can only be edited for the current fiscal year");
                    return;
                }

                //Make sure the selected narrative can be edited (new or revised, but not current)
                //  I don't trust the "text" status as the client may want to change it.  Let's make the determination
                //  the same way the BL does from the raw data.
                let nar = this._selectedNarrative;
                let narrativeIsPublished = nar.publish.toUpperCase() == "Y";
                let narrativeHasBeenChanged = nar.narrative_has_revisions || nar.narrative_revision_points_have_been_edited;
                if (narrativeIsPublished && !narrativeHasBeenChanged) {
                    //This is a current, unaltered narrtive, so there's nothing to do here.  Points can't be added without a revision.
                    this.growlBox.addGrowl("warn", "The selected narrative is Published and Current.  Its points cannot be edited until a revision has been created.");
                    return;
                }

                let route = "/cpdes/capp/edit/{0}/{1}/{2}".format(this._fiscalYear, this._practiceStateId, this._selectedNarrative.revision_narrative_id || this._selectedNarrative.practice_narrative_id);
                this.router.navigate([route]);
                break;

            case "act_approve":
                this.approveForPublishing();
                break;

            case "act_publish":
                this.publishImmediately();
                break;

            case "act_manage_capp":
                // Navigate to this asset on Narrative List page
                let cappRoute = "/cpdes/practices/narrativesList/{0}".format(this._practiceId);
                this.router.navigate([cappRoute]);
                break;
        }

    };


    // UI - EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // approveForPublishing
    //==================================
    approveForPublishing() {
        if (!this._selectedNarrative) {
            this.growlBox.addGrowl("info", "No row selected");
            return;
        }
        let approvable = (this._selectedNarrative.narrative_has_revisions) || (this._selectedNarrative.narrative_status.toUpperCase() == "NEW");
        if (!approvable) {
            this.growlBox.addGrowl("warn", "No changes to existing narrative or points have been detected");
            return;
        }
        this.approveForPublishingPopup.Open();
    }

    //==================================
    // ApproveNarrativeForPublishing
    //==================================
    ApproveNarrativeForPublishing() {

        this.growlBox.addGrowl("info", "Approving narrative...");

        this.webServices.Post("/narrative/approveNarrativeForPublishing", this.getSelectedNarrativeId())
            .then(res => {
                console.log("[{0}:/narrative/approveNarrativeForPublishing] - res:".format(this._componentName), res);

                if (res.Success) {

                    this.growlBox.addGrowl("success", "Narrative approved");
                    //Since we no longer leave the page after save (508), we need to relead the narrative and its revision
                    this.loadNarratives();
                }
                else {
                    this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res));
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            })        
    }

    //==================================
    // publishImmediately
    //==================================
    publishImmediately() {
        if (!this._selectedNarrative) {
            this.growlBox.addGrowl("info", "No row selected");
            return;
        }
        let isNew = (this._selectedNarrative.publish.toUpperCase() != "Y");
        if (!isNew) {
            this.growlBox.addGrowl("warn", "Only new narratives can be published immediately");
            return;
        }
        let publishImmediately = (this._selectedNarrative.publish_mode == 1);
        if (!publishImmediately) {
            this.growlBox.addGrowl("warn", "Only narratives with publish action \"Immediately\" can be published immediately");
            return;
        }
        this.publishNarrative();
    }

    //==================================
    // publishNarrative
    //==================================
    publishNarrative() {
        this.growlBox.addGrowl("info", "Publishing narrative...");
        let narrativeId = this.getSelectedNarrativeId();
        this.webServices.Post("/narrative/publishNarrative", narrativeId)
            .then(res => {
                console.log("[{0}:/narrative/publishNarrative()] - res:".format(this._componentName), res);

                if (res.Success) {
                    this.growlBox.addGrowl("success", "Narrative and associated data published successfully");
                    //Since we no longer leave the page after save (508), we need to relead the narrative and its revision
                    this.loadNarratives();
                }
                else {
                    this.growlBox.addGrowl("error", "This is an existing boilerplate message from server. No specific detail provided in this error message allowed");
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            })      
    }

    //==================================
    // getSelectedNarrativeId
    //==================================
    getSelectedNarrativeId() {
        let narrativeId = this._selectedNarrative.practice_narrative_id;
        let hasRevision = this._selectedNarrative.revision_narrative_id != null;
        if (hasRevision) {
            narrativeId = this._selectedNarrative.revision_narrative_id;
        }
        return narrativeId;
    }

    //==================================
    // gridRefreshClicked
    //==================================
    gridRefreshClicked() {
        this.loadNarratives();
    }

    //==================================
    // onCellClicked
    //==================================
    onCellClicked(cell) {
        //console.log("onCellClicked:", cell.col.fieldName, ": ", cell.row.practice_narrative);
        //console.log("onCellClicked:", cell);
        if (!cell.isCheckbox && cell.col.fieldName == "practice_narrative") {
            this._fullTextDisplay = cell.row.practice_narrative;
            this.fullTextPopup.Open();
        }
    }

    //==================================
    // onRowSelectionChanged 
    //==================================
    onRowSelectionChanged(row) {

        //This is called when a row is selected AND unselected, resulting in a "null" selected row when unselected
        //console.log("  [{0}:gridRowSelected()] row:".format(this._componentName), this._selectedRow);

        if (this.mainGrid) {
            this._selectedNarrative = this.mainGrid.GetFirstSelectedRow();

            if (this._selectedNarrative) {
                this._sessionStorageObject.selectedNarrativeId = this._selectedNarrative.practice_narrative_id;
                this._saveSessionStorageObject(this._sessionStorageObject);
                console.log("  [{0}:gridRowSelected()] row:".format(this._componentName), this._selectedNarrative);
            }
            else {
                this._sessionStorageObject.selectedNarrativeId = null;
                this._saveSessionStorageObject(this._sessionStorageObject);
            }
        }
    }

    //==================================
    // onGridSearch
    //==================================
    onGridSearch(searchText){

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter
        if (!searchText || searchText.length == 0){
            this.mainGrid.ClearFilter(searchFilterName, applyImmediately);
            this.sendJawsNotification("The list has updated");
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return (
                row.practice_narrative_code.toLowerCase().indexOf(searchText) >= 0 ||
                //row.narrative_status.toLowerCase().indexOf(searchText) >= 0 || 
                //row.point_status.toLowerCase().indexOf(searchText) >= 0 || 
                //row.publish_action.toLowerCase().indexOf(searchText) >= 0 || 
                //row.approval_status.toLowerCase().indexOf(searchText) >= 0 ||             //Add back after these are supported
                row.practice_narrative.toLowerCase().indexOf(searchText) >= 0     
            );
        };

        //Set the "search" filter on the grid
        this.mainGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        this.sendJawsNotification("The list has updated");
    }

    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    //==================================
    // onPageChanged
    //==================================
    // $event will contain the new page
    onPageChanged($event) {

        var newPage = $event;
    
        //Store the new page in the local storage
        this._sessionStorageObject.currentPage = newPage;
        this._saveSessionStorageObject(this._sessionStorageObject);
    }

    //==================================
    // onSort
    //==================================
    onSort(event) {

        var column = event;

        //Store the new page in the local storage
        this._sessionStorageObject.sortColumn = column ? column.fieldName : "practice_narrative_code";
        this._sessionStorageObject.sortDirection = column ? column.sorted : "A";
        this._saveSessionStorageObject(this._sessionStorageObject);
    }


    // BUSINESS LOGIC & NON-UI EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // loadFY
    //=======================================
    loadFY(fnOnComplete, fnOnError) {

        this._markGridAsLoading(true);

        this.webServices.Get({
            apiPath: "/fiscalyear/getCurrentFiscalYear"
        })
        .then(res => {
            console.log("[{0}:loadFY():/fiscalyear/getCurrentFiscalYear] - res:".format(this._componentName), res);
            let dto = res.data.DTO;
            this._markGridAsLoading(false);
            try {
                if (fnOnComplete) { fnOnComplete(dto); }
            }
            catch(err){
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log("[ERROR][{0}:loadNarratives()]".format(this._componentName), err);
                return;
            }

        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    }

    //=======================================
    // loadNarratives
    //=======================================
    loadNarratives(fnOnComplete, fnOnError) {

        this._markGridAsLoading(true);

        this.webServices.Get({
            apiPath: "/narrative/getNarrativeListForDashboard",
            args: {
                practiceStateId: this._practiceStateId,
                fy: this._fiscalYear
            }
        })
        .then(res => {
            console.log("[{0}:loadNarratives():/narrative/getNarrativeListForDashboard] - res:".format(this._componentName), res);
            let dto = res.data.DTO;
            this._setGridRows(dto);
            this._markGridAsLoading(false);

            this._syncGridToSessionData();

            try {
                if (fnOnComplete) { fnOnComplete(dto); }
            }
            catch(err){
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log("[ERROR][{0}:loadNarratives()]".format(this._componentName), err);
                return;
            }

        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    }

    //=======================================
    // loadPracticeState
    //=======================================
    loadPracticeState(practiceStateId, fnOnComplete, fnOnError) {

        this.webServices.Get({
            apiPath: "/practices/getPracticeState",
            args: {
                practiceStateId: practiceStateId
            }
        })
        .then(res => {

            console.log("[{0}:loadPracticeState():getPracticeState] - res:".format(this._componentName), res);
            let dto = res.data.DTO;

            try {
                if (fnOnComplete) { fnOnComplete(dto); }
            }
            catch(err){
                this.growlBox.addGrowl("error", "An unexpected error has occurred");
                console.log("[ERROR][{0}:getPracticeState()]".format(this._componentName), err);
                return;
            }

        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
            if (fnOnError) { fnOnError(); }
        });
    }


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _generateNarrativeTextLink(narrative)
    //==================================
    _generateNarrativeTextLink(narrative) {
        return "<span title='Click to view full text' class='fake-anchor' style='pointer-events:none;'>{0}</span>".format(this.helpers.truncateString(narrative, 80));
    }

    //==================================
    // _loadSessionStorageObject
    //==================================
    _loadSessionStorageObject() {
        var obj = sessionStorage.getItem(this._formName);
        return obj ? JSON.parse(obj) : null;
    }

    //==================================
    // _markGridAsLoading
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _markGridAsLoading(isLoading) {

        if (this.mainGrid){
            this.mainGrid.MarkAsLoading(isLoading);
        }
        else{
            this._mainGridSettings.loading = isLoading;
        }
    }

    //==================================
    // _markPageAsLoading
    //==================================
    _markPageAsLoading(isLoading) {
        this._pageLoading = isLoading;
    }

    //==================================
    // _saveSessionStorageObject
    //==================================
    _saveSessionStorageObject(obj) {
        if (!obj) { throw "[{0}:_saveSessionStorageObject] - obj must not be empty".format(this._componentName) }
        sessionStorage.setItem(this._formName, JSON.stringify(obj));
    }

    //==================================
    // _setGridRows
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here we'll test and see if we need to change the underlying settings
    // or the loaded object.
    _setGridRows(data) {

        if (this.mainGrid){
            this.mainGrid.SetRows(data);
        }
        else{
            this._mainGridSettings.rows = data;
        }
    }

    //==================================
    // _sortGrid
    //==================================
    _sortGrid(column, direction) {

        // Let's give the grid a chance to render for a bit and then sort
        // once it comes up.  Keep it tight though, or we'll sort too long
        // after the grid comes up.
        this.helpers.executeOnCondition(
            () => { return !!this.mainGrid; },
            () => { this.mainGrid.SortGrid(column, direction); },
            50, 10
        );
    }

    //==================================
    // _syncGridToSessionData
    //==================================
    _syncGridToSessionData(){

        //Wrap this in an async wait in case the grid hasn't loaded yet
        this.helpers.executeOnCondition(
            () => { return !!this.mainGrid; },
            () => { 
                
                //Apply a sort
                this.mainGrid.SortGrid(
                    this._sessionStorageObject.sortColumn || "practice_narrative_code", 
                    this._sessionStorageObject.sortDirection || "A"
                );

                //Check to see if we have a stored page to return to
                if (this._sessionStorageObject.currentPage) {
                    if (!this.mainGrid.SetPage(this._sessionStorageObject.currentPage)){
                        //Response was false, page was not found.  Clear from the session storage
                        this._sessionStorageObject.currentPage = 1;
                    }
                }

                //Check to see if a narrative is selected
                if (this._sessionStorageObject.selectedNarrativeId) {
                    if (!this.mainGrid.SelectRowByPayloadValue("practice_narrative_id", this._sessionStorageObject.selectedNarrativeId)) {
                        //Response was false, row was not found.  Clear from the session storage
                        this._sessionStorageObject.selectedNarrativeId = null;
                    }
                }



            }, 50, 10
        );        

    }

    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //=======================================
    // debugEntryClicked
    //=======================================
    debugEntryClicked(entry) {

        console.log("[{0}:debugEntryClicked]".format(this._componentName));
        console.log("    ", entry);

        //switch (entry) {

        //    case "Navigate to Edit":
        //        this.router.navigate(["/cpdes/capp/edit/2019/41771"]);
        //        break;
        //}
    };

};
